import React, { useState, useEffect, useContext } from 'react';
import { useSMSService } from '../../hooks/services/sms';
import GlobalContext from '../../contexts/GlobalContext';
import { isCorrectPlaceToShowSMSPopup } from '../../utils/sms';
import SMSPopup from './SMSPopup';
import { SMSPopupInfo } from '../../types/sms';
import SMSThanksPopup from './SMSThanksPopup';
import parse from 'html-react-parser';

const SMSContainer = (): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const initialSMSPopupInfo: SMSPopupInfo = {
    countryCode: window?.caastle?.localeInfo?.countryCode || 'US',
    serviceName: String(parse(globalContext.gb.liquid.settings.service_name)),
    isSMSServiceEnabled: false,
    optInPopupSeen: false,
    hideSMS: true,
    showSmsPopup: true,
    showThanksPopup: false,
    isFirstBoxShipped: false
  };
  const [smsPopupInfo, setSmsPopupInfo] = useState<SMSPopupInfo>(initialSMSPopupInfo);
  const fetchSMS = useSMSService({
    onSuccess: (smsData) => {
      const showSMS = isCorrectPlaceToShowSMSPopup(globalContext) &&
      smsData?.isSMSServiceEnabled && !smsData?.optInPopupSeen;
      const newSMSPopupInfo = { ...smsPopupInfo, ...smsData, hideSMS: !showSMS };

      setSmsPopupInfo(newSMSPopupInfo);
      sessionStorage.setItem('smsPopupInfo', JSON.stringify(newSMSPopupInfo));
    },
    onError: (error) => {
      console.log(error);
    },
    sourceEventId: globalContext.emitter.sourceEventId,
    clusterValue: globalContext.gb.utils.getClusterValue()
  });

  useEffect(() => {
    const newSMSPopupInfo = sessionStorage.getItem('smsPopupInfo');

    if (newSMSPopupInfo) {
      const newSMSPopupInfoObj = JSON.parse(newSMSPopupInfo);
      const showSMS = isCorrectPlaceToShowSMSPopup(globalContext) &&
      newSMSPopupInfoObj?.isSMSServiceEnabled && !newSMSPopupInfoObj?.optInPopupSeen;

      setSmsPopupInfo({ ...newSMSPopupInfoObj, hideSMS: !showSMS });
    } else {
      fetchSMS.refetch();
    }
  }, []);

  const displaySMSPopup = smsPopupInfo.showSmsPopup && !smsPopupInfo.showThanksPopup;

  return (
    (fetchSMS.isSuccess || !smsPopupInfo.hideSMS) ?
        <div data-testid="js-sms-popup" id="js-sms-popup" className="reveal-overlay" style = {{ display: smsPopupInfo.hideSMS ? 'none' : 'block' }} >
           { displaySMSPopup && <SMSPopup
           smsPopupInfo = {smsPopupInfo}
           setSmsPopupInfo = {setSmsPopupInfo}
           />}
           {
            smsPopupInfo.showThanksPopup && <SMSThanksPopup smsPopupInfo = {smsPopupInfo} setSmsPopupInfo = {setSmsPopupInfo} />
           }
        </div> : <></>
  );
};

export default SMSContainer;
